import React, { useState, useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Col, Row, Button, Form, FormControl, Modal } from "react-bootstrap";
import Cookie from "js-cookie";
import * as _ from "../../../../constants/Constants";
import * as rolePermConsts from "../../../../constants/RolePermissionConstants";
import { updateCommonInfo } from "../../../../redux/commonSlice";
import {
  updateVendorProfileDetails,
  updateServiceData,
} from "../../../../redux/serviceSlice";
import { extractVendorStatus } from "../../OnboardingContainer";
import { getUserRolePermission } from "../../../../utils/rolePermissionAccess";
import { checkOnBoardingStatus } from "../../../../utils/utils";
import { isValidDuns } from "../../../../utils/validations/validations";
import OnSubmitErrorMessage from "../../../Common/Errors/OnSubmitErrorMessage";
import {
  httpGetVendorStatusDetails,
  httpGetAllHierarchyDivision,
  httpGetHierarchyByDivisionNumber,
  // httpPostSendAccountPayableEmail,
  httpPostSaveVendorStatusByProfileId,
  httpGetVendorNumberByDeptNumAndDuns,
  httpPostRequestNewDVN,
  httpGetVendorProfileById,
  httpPostHirarchySave,
  httpPostMainframeSuffixError,
} from "../../../../service/httpClient";
import DisplayStatus from "../../../Common/DisplayStatus/DisplayStatus";
import DunsWrapper from "../../../Common/DunsWrapper/DunsWrapper";
import * as Validations from "../../../../utils/validations/validations";
import * as Constants from "../../../../constants/Constants";
import axios from "../../../../service/axios";
import ErrorContainer from "../../../Common/Errors/ErrorContainer";
import { AgGridReact } from "ag-grid-react";
import "../../../Common/Tooltip/ToolTip.css";
import "../../../../assets/css/Common.css";
import "./DVNSetup.css";
const utils = require("lodash");

const getSortedArrayBasedOnVendorNumber = (hierarchyArr) => {
  return [
    ...hierarchyArr.sort((a, b) => {
      let firstDep = parseInt(a?.dept);
      let secDep = parseInt(b?.dept);

      if (firstDep && secDep) {
        return firstDep - secDep;
      }
      return;
    }),
  ];
};
const getHierarchy = (vendorDetails, rolePermissionForEntirePage) => {
  if (
    vendorDetails.hierarchyDetails &&
    vendorDetails.hierarchyDetails.length > 0
  ) {
    let unSortedHierarchyDetails = [...vendorDetails.hierarchyDetails];
    let sortedHierarchyDetails = getSortedArrayBasedOnVendorNumber(
      unSortedHierarchyDetails
    );
    return [...sortedHierarchyDetails];
  }
  if (vendorDetails && rolePermissionForEntirePage === rolePermConsts.EDIT) {
    return [
      {
        dept: "",
        divisionName: "",
        gmmName: "",
        isPrimary: false,
        isOperDivPrimary: false,
        operatingDivision: "",
        vendorNumber: "",
        vendorProfileId: vendorDetails.id || "",
      },
    ];
  }

  return [];
};
const getEventDvnName = (eventId) => {
  switch (eventId) {
    case 12:
      return "MACY'S";
    case 13:
      return "BLOOMINGDALE'S";
    case 1027:
      return "BLOOMINGDALES OUTLET";
    case 6315:
      return "MACY'S BACKSTAGE";
    default:
      return eventId;
  }
};
const defaultColDef = {
  lockVisible: true,
  suppressMovable: true,
  filter: false,
  sortable: false,
  resizable: true,
};
const columnDefs = [
  {
    headerName: "Operating Div",
    field: "divNbr",
    width: 90,
  },
  {
    headerName: "Dept",
    field: "deptNbr",
    width: 70,
  },
  {
    headerName: "Vendor",
    field: "vndNumericDesc",
    width: 70,
  },
  {
    headerName: "Error message",
    field: "errorDesc",
    width: 400,
  },
];

const DVNSetup = ({
  vendorProfileDetails,
  onboardingStatus,
  viewOnMerchApproval,
  merchApprovalStateUpdate,
  hierarchyHasDuplicate,
  dunsValidatorHandler,
  dunsExists,
  parentAccessDisabled,
  parentStatusMsgRefreshHandler,
  history,
  submitMerchantContactApproval,
  merchantApprovalState,
  validator,
  merchApprovalBrandMappingUpdate,
  getDocumentList,
  refreshDataAfterActionSuccessful,
}) => {
  const rolePermissionForEntireDVNPage = getUserRolePermission(
    rolePermConsts.VENDORPLATFORM_PREBOARDING_DVNSETUP,
    rolePermConsts.ALL
  );
  const rolePermissionForEntireDVNPage_MA = getUserRolePermission(
    rolePermConsts.VENDORPLATFORM_COMPANYINFORMATION_MERCHANTAPPROVAL,
    rolePermConsts.ALL
  );
  // const rolePermissionForPrimaryDVNCheckBox = getUserRolePermission(
  //   rolePermConsts.VENDORPLATFORM_PREBOARDING_DVNSETUP,
  //   rolePermConsts.VMP_PRIMARYDVNCHECKBOX
  // );
  //For DVN page
  const rolePermissionForRemoveButton = getUserRolePermission(
    rolePermConsts.VENDORPLATFORM_PREBOARDING_DVNSETUP,
    rolePermConsts.VMP_REMOVE
  );
  const rolePermissionForAddButton = getUserRolePermission(
    rolePermConsts.VENDORPLATFORM_PREBOARDING_DVNSETUP,
    rolePermConsts.VMP_ADD
  );
  const rolePermissionForApproveButton = getUserRolePermission(
    rolePermConsts.VENDORPLATFORM_PREBOARDING_DVNSETUP,
    rolePermConsts.VMP_APPROVE
  );
  const rolePermissionForAssignNewDVNsAndDuns = getUserRolePermission(
    rolePermConsts.VENDORPLATFORM_PREBOARDING_DVNSETUP,
    rolePermConsts.VMP_ASSIGN_NEW_DVNS_AND_DUNS
  );
  const rolePermissionForHierarchySelection = getUserRolePermission(
    rolePermConsts.VENDORPLATFORM_PREBOARDING_DVNSETUP,
    rolePermConsts.VMP_HIERARCHYSELECTION
  );
  const rolePermissionForReValidateButton = getUserRolePermission(
    rolePermConsts.VENDORPLATFORM_PREBOARDING_DVNSETUP,
    rolePermConsts.VMP_REVALIDATE
  );
  const rolePermissionForBrandMappingCheckbox = getUserRolePermission(
    rolePermConsts.VENDORPLATFORM_PREBOARDING_DVNSETUP,
    rolePermConsts.VMP_BRAND_MAPPING_CHECKBOX
  );
  const rolePermissionForBrandMappingViewModifyButton = getUserRolePermission(
    rolePermConsts.VENDORPLATFORM_PREBOARDING_DVNSETUP,
    rolePermConsts.VMP_BRAND_MAPPING_VIEW_MODIFY_BUTTON
  );
  const rolePermissionForActionRequiredFromMainframeMsgView =
    getUserRolePermission(
      rolePermConsts.VENDORPLATFORM_PREBOARDING_DVNSETUP,
      rolePermConsts.VMP_MAINFRAME_ACTION_REQUIRED_MSG
    ) === rolePermConsts.VIEW;

  //For Merchant approval page
  const rolePermissionForRemoveButton_MA = getUserRolePermission(
    rolePermConsts.VENDORPLATFORM_COMPANYINFORMATION_MERCHANTAPPROVAL,
    rolePermConsts.VMP_REMOVE
  );
  const rolePermissionForAddButton_MA = getUserRolePermission(
    rolePermConsts.VENDORPLATFORM_COMPANYINFORMATION_MERCHANTAPPROVAL,
    rolePermConsts.VMP_ADD
  );
  const rolePermissionForHierarchySelection_MA = getUserRolePermission(
    rolePermConsts.VENDORPLATFORM_COMPANYINFORMATION_MERCHANTAPPROVAL,
    rolePermConsts.VMP_HIERARCHYSELECTION
  );
  const rolePermissionForReValidateButton_MA = getUserRolePermission(
    rolePermConsts.VENDORPLATFORM_COMPANYINFORMATION_MERCHANTAPPROVAL,
    rolePermConsts.VMP_REVALIDATE
  );
  const rolePermissionForBrandMappingViewModifyButton_MA = getUserRolePermission(
    rolePermConsts.VENDORPLATFORM_COMPANYINFORMATION_MERCHANTAPPROVAL,
    rolePermConsts.VMP_BRAND_MAPPING_VIEW_MODIFY_BUTTON
  );
  const rolePermissionForBrandMappingCheckbox_MA = getUserRolePermission(
    rolePermConsts.VENDORPLATFORM_COMPANYINFORMATION_MERCHANTAPPROVAL,
    rolePermConsts.VMP_BRAND_MAPPING_CHECKBOX
  );

  const dispatch = useDispatch();

  const [changedField, setChangedField] = useState("");
  const [dvnDetails, setDvnDetails] = useState({
    vendorDetails: null,
    hierarchyArr: [],
    operatingDivisions: [],
    deptByMacys: [],
    deptByBloomingdales: [],
    deptByBloomingdalesOutlet: [],
    deptByMacysBackstage: [],
    vendorNumberByDept: {},
    disableApproveButton: false,
    disableAssignNewDVNsButton: false,
    hasDuplicateHierarchyEntry: false,
    dvnUpdateStatus: {
      error: "",
      success: "",
    },
    dvnSetupStatus: "",
    dvnSetupStatusMsg: "",
    disableViewModifyButton: false,
  });
  const [suffixErrorMessage, setSuffixErrorMessage] = useState("");
  const [suffixErrorMessageFlag, setSuffixErrorMessageFlag] = useState(false);
  const store = useSelector(
    ({ service, common }) => ({
      vendorProfile: service.vendorProfile,
      vendorDetails: service.vendorProfile?.vendorDetail,
      profileId: common.profileId,
      vendorStatus: service.vendorStatus || [],
      vendorCorpName: common.vendorCorpName,
      userEmail: common.userEmail,
      duns: common.duns,
      notes: service.notes,
      mandatoryDocRes: common?.mandatoryDocRes,
      documentList: common.documentList,
      merchandiseType:
        service.vendorProfile?.vendorDetail?.merchandiseType || "",
    }),
    shallowEqual
  );

  const dunsvalid =
    !utils.isNil(vendorProfileDetails) &&
    (store.duns || vendorProfileDetails?.duns)
      ? true
      : false;
  const vendorProfileId = vendorProfileDetails?.id || "";
  // const isMerchantApproved = viewOnMerchApproval
  //   ? viewOnMerchApproval
  //   : vendorProfileDetails?.status === _.APPROVED;

  const [isDunsValidated, setIsDunsValidated] = useState(dunsvalid);
  const [isValidDunsNumber, setIsValidDunsNumber] = useState(false);
  const [isVendorPresent, setIsVendorPresent] = useState(false);
  const [isOwnVendorProfile, setIsOwnVendorProfile] = useState(false);
  const [isOnChangeVaildDuns, setIsOnChangeVaildDuns] = useState(false);
  const [dunValidationMsg, setDunValidationMsg] = useState("");
  const [dunValidationErrorMsg, setDunValidationErrorMsg] = useState("");
  const [hasErrorIndex, setHasErrorIndex] = useState(-1);
  const [errorModal, setErrorModal] = useState(false);
  const [errorList, setErrorList] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [duns, setDuns] = useState(store.duns || vendorProfileDetails.duns);
  const [hasBrandMapping, setHasBrandMapping] = useState(false);
  const [validationErrorMessage, setValidationErrorMessage] = useState(false);
  const [isEmpltyHierarchy, setIsEmpltyHierarchy] = useState(true);
  const [actionRequiredMainframe, setActionRequiredMainframe] = useState(false);
  const [actionRequiredMessage, setActionRequiredMessage] = useState("");
  const getDunsCheckMarkSatus = () => {
    return !utils.isEmpty(duns) && isDunsValidated && isValidDunsNumber;
  };

  const handleErrorBtn = () => {
    axios()
      .get(`/jobrequest/dvn-errors/${vendorProfileId}`)
      .then((res) => {
        const errorDt =
          (res.data.dvnData &&
            res.data.dvnData.filter((item) => item.errorCode > 0)) ||
          [];
        const newErrList = errorDt.map((item) => {
          item.divNbr = getEventDvnName(item.divNbr);
          return item;
        });
        setErrorList(newErrList);
        setErrorModal(true);
        setErrorMessage("");
      })
      .catch((err) => {
        setErrorList([]);
        setErrorModal(true);
        setErrorMessage(err.message);
      });
  };

  const handleOkClick = () => {
    setErrorModal(false);
  };

  const handleErrorClose = () => {
    setErrorModal(false);
  };

  const getShowErrorMessages = () => {
    return (
      <Modal
        className="exports-modal"
        show={errorModal}
        onHide={handleErrorClose}
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title>DVN Request Errors</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {errorMessage && (
            <div className="d-flex justify-content-between">
              <ErrorContainer
                errorMsg={errorMessage}
                errorStatus={true}
                errorStyle="errorMessage"
              />
            </div>
          )}
          {errorList && errorList.length > 0 && (
            <div
              id="errorTable_new"
              className="ag-theme-balham retryFailureTable error_list"
            >
              <AgGridReact
                columnDefs={columnDefs}
                rowData={errorList}
                defaultColDef={defaultColDef}
                overlayNoRowsTemplate={"No Data Available"}
              />
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button className="button-primary-md" onClick={handleOkClick}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  const getErrorStatus = () => {
    return (
      isVendorPresent &&
      !isOwnVendorProfile &&
      !isOnChangeVaildDuns &&
      Validations.isValidDuns(duns)
    );
  };

  const getDunsValidationStatus = () => {
    return (
      !utils.isEmpty(duns) &&
      isDunsValidated &&
      isValidDunsNumber &&
      ((!isVendorPresent && !isOwnVendorProfile) ||
        (isVendorPresent && isOwnVendorProfile))
    );
  };

  const validateMerchantData = () => {
    let disableBtn = false;
    let disableBtnForInvalidField = false;
    let disableBtnForInvalidHierarchy = false;
    let disableBtnForInvalidDuns = false;
    // Below code is to introduce form validation against Hierarchy values
    if (hierarchyArr?.length > 0) {
      hierarchyArr.forEach((hier) => {
        const { dept, operatingDivision, vendorNumber } = hier;

        if (!dept || !operatingDivision || vendorNumber === "") {
          disableBtnForInvalidHierarchy = true;
        }
      });
    } else {
      disableBtnForInvalidHierarchy = false;
    }
    if ((duns && !Validations.isValidDuns(duns)) || !isDunsValidated) {
      disableBtnForInvalidDuns = true;
    }
    if (
      disableBtnForInvalidField ||
      disableBtnForInvalidHierarchy ||
      disableBtnForInvalidDuns
    ) {
      disableBtn = true;
    }
    return disableBtn;
  };

  const getMerchanteApproveBtnEnable = () => {
    if (viewOnMerchApproval) {
      return (
        !validator ||
        !merchantApprovalState.editPermission ||
        merchantApprovalState.disableBtn ||
        merchantApprovalState.disableOnSubmit ||
        merchantApprovalState.hierarchyDuplicate
      );
    }
    return (duns && validateMerchantData()) || false;
  };

  const {
    vendorDetails,
    hierarchyArr,
    operatingDivisions,
    deptByMacys,
    deptByBloomingdales,
    deptByBloomingdalesOutlet,
    deptByMacysBackstage,
    disableApproveButton,
    disableAssignNewDVNsButton,
    hasDuplicateHierarchyEntry,
    dvnUpdateStatus,
    vendorNumberByDept,
  } = dvnDetails;

  useEffect(() => {
    getOperatingDivisions();
    checkIfButtonShouldBeDisabled();
    const rolePermission = viewOnMerchApproval
      ? rolePermissionForEntireDVNPage_MA
      : rolePermissionForEntireDVNPage;
    setDvnDetails((state) => ({
      ...state,
      hierarchyArr: getHierarchy(vendorProfileDetails, rolePermission),
      vendorDetails: {
        ...state.vendorDetails,
        ...vendorProfileDetails,
      },
    }));
    getMerchanteApproveBtnEnable();
  }, [vendorProfileDetails, store.vendorProfile]);
  useEffect(() => {
    checkIfBrandMappingValid(hierarchyArr);
  }, []);
  useEffect(() => {
    checkIfBrandMappingValid(hierarchyArr);
  }, [merchantApprovalState]);
  useEffect(() => {
    let ifNewDVNHasToAssign = hierarchyArr.some(
      (item) => item.vendorNumber === "0"
    );

    if (changedField === "vendorNumber") {
      checkForDuplicateHierarchyEntry();
    }

    if (ifNewDVNHasToAssign) {
      setDvnDetails((state) => ({
        ...state,
        disableAssignNewDVNsButton: false,
      }));
    } else {
      setDvnDetails((state) => ({
        ...state,
        disableAssignNewDVNsButton: true,
      }));
    }

    if (
      hierarchyArr.length > 0 &&
      !operatingDivisions.length &&
      !(
        changedField === "dvnDeptNumber" ||
        changedField === "vendorNumber" ||
        changedField === "primaryDVN"
      )
    ) {
      getDeptmentsByOperatingDivision(hierarchyArr);
    }

    if (
      vendorDetails &&
      duns &&
      isDunsValidated &&
      hierarchyArr.length > 0 &&
      !(changedField === "primaryDVN" || changedField === "operatingDivision")
    ) {
      getGetVendorNumberByDeptNumAndDuns(hierarchyArr);
    }

    checkIfButtonShouldBeDisabled();

    checkIfBrandMappingValid(hierarchyArr);
  }, [hierarchyArr, isDunsValidated]);

  useEffect(() => {
    if (!viewOnMerchApproval && store?.documentList?.length === 0)
      getDocumentList(store?.profileId);
  }, []);

  useEffect(() => {
    let dvnSetupStatus = "";
    let dvnSetupStatusMsg = "";
    if (store.vendorStatus.length > 0) {
      const setupDvn = store.vendorStatus.find(
        (item) => item.statusName === Constants.DVN_SET_UP_ID
      );
      if (setupDvn && setupDvn.vendorStatus) {
        dvnSetupStatus = setupDvn.vendorStatus.lastStatusUpdatedValue || "";
        switch (dvnSetupStatus) {
          case Constants.DVN_SETUP_STATUS_PENDING:
            dvnSetupStatusMsg =
              Constants.DVN_SETUP_MSG.DVN_SETUP_STATUS_PENDING_MSG;
            break;
          case Constants.DVN_SETUP_STATUS_COMPLETE:
            dvnSetupStatusMsg =
              Constants.DVN_SETUP_MSG.DVN_SETUP_STATUS_COMPLETE_MSG;
            break;
          case Constants.DVN_SETUP_STATUS_ERROR:
            dvnSetupStatusMsg =
              Constants.DVN_SETUP_MSG.DVN_SETUP_STATUS_ERROR_MSG;
            break;
          default:
            dvnSetupStatus = "";
            dvnSetupStatusMsg = "";
        }
      }
    }
    setDvnDetails((prevState) => ({
      ...prevState,
      dvnSetupStatus,
      dvnSetupStatusMsg,
    }));
  }, [store.vendorStatus]);

  useEffect(() => {
    if (store?.merchandiseType === Constants.VOB_MERCHANDISE_TYPE_CONSIGNMENT) {
      let actionRequiredMsg = store?.notes?.filter(
        (note) =>
          note?.noteType === Constants.NOTES_TYPE.setupDvnSuffixes &&
          note?.notes
      );
      if (actionRequiredMsg?.length > 0) {
        setActionRequiredMainframe(true);
        const message = String(actionRequiredMsg[0]?.notes).replace(
          /1|2|3|4|5|6|7|8|9|0/gi,
          (matched) => '<span style="color:#ea191a;">' + matched + "</span>"
        );
        setActionRequiredMessage(
          <p dangerouslySetInnerHTML={{ __html: message }} />
        );
      }
    }
  }, [store.notes]);

  const checkIfBrandMappingValid = () => {
    const keys = [
      "operatingDivision",
      "dept",
      "vendorNumber",
      "brandName",
      "terms",
      "termsDays",
      "programTypes",
      "freightCode",
      "returnDisposition",
    ];
    let status = true;

    const isVendorConnectionVDIRDS = () => {
      if (viewOnMerchApproval) {
        return (
          merchantApprovalState &&
          merchantApprovalState.merchantDetails &&
          merchantApprovalState.merchantDetails.vendorConnectionPlatform ===
            "directEdiRDS"
        );
      } else {
        if (vendorDetails) {
          return vendorDetails.vendorConnectionPlatform === "directEdiRDS";
        }
        return false;
      }
    };

    hierarchyArr.forEach((item) => {
      if (status) {
        for (let key of keys) {
          if (key === "programTypes" && isVendorConnectionVDIRDS()) {
            if (!item[key] || (item[key] && item[key].length === 0)) {
              status = false;
              break;
            }
          }
          if (
            key === "brandName" &&
            item.vendorNumber === "0" &&
            (item[key] === null || item[key] === "" || item[key] === undefined)
          ) {
            status = false;
            break;
          }
          if (
            key !== "returnDisposition" &&
            key !== "programTypes" &&
            key !== "brandName" &&
            (item[key] === null || item[key] === "" || item[key] === undefined)
          ) {
            status = false;
            break;
          }
          if (
            store?.merchandiseType !==
            Constants.VOB_MERCHANDISE_TYPE_MARKETPLACE
          ) {
            if (
              key === "returnDisposition" &&
              item.vendorNumber === "0" &&
              (item[key] === null ||
                item[key] === "" ||
                item[key] === undefined ||
                item[key] === "none")
            ) {
              status = false;
              break;
            }
          }
        }

        if (
          store?.merchandiseType !== Constants.VOB_MERCHANDISE_TYPE_MARKETPLACE
        ) {
          if (
            item?.salvageAllowance &&
            typeof item.returnDisposition === "string" &&
            item?.returnDisposition.indexOf("salAllow") === -1 &&
            (!item?.salvageAllowance ||
              (item?.salvageAllowance && item?.salvageAllowance?.length === 0))
          ) {
            status = false;
          }
          if (
            item?.receiptAllowance &&
            (!item?.receiptAllowance ||
              (item?.receiptAllowance && item?.receiptAllowance?.length === 0))
          ) {
            status = false;
          }
        }
      }
    });

    setHasBrandMapping(status);
    merchApprovalBrandMappingUpdate && merchApprovalBrandMappingUpdate(status);
  };

  const getOperatingDivisions = () => {
    httpGetAllHierarchyDivision().then((res) => {
      setDvnDetails((state) => ({
        ...state,
        operatingDivisions: res.data,
      }));
    });
  };

  const getDeptmentsByOperatingDivision = async (vendorHierarchyArr) => {
    let operatingDivisionList = vendorHierarchyArr.map(
      (item) => item.operatingDivision
    );

    let operatingDivisionUnique = operatingDivisionList.reduce(
      (operatingDivision1, operatingDivision2) => {
        if (operatingDivision1.indexOf(operatingDivision2) < 0)
          operatingDivision1.push(operatingDivision2);
        return operatingDivision1;
      },
      []
    );
    operatingDivisionUnique.forEach((operatingDivision) => {
      if (operatingDivision) {
        getDeptByOperatingDivision(operatingDivision, null, null);
      }
    });
  };

  const getDeptByOperatingDivision = (selectedOpDiv, event, index) => {
    if (
      deptByMacys.length === 0 ||
      deptByBloomingdales.length === 0 ||
      deptByBloomingdalesOutlet.length === 0 ||
      deptByMacysBackstage.length === 0
    ) {
      httpGetHierarchyByDivisionNumber(selectedOpDiv).then((res) => {
        const { data = [], status } = res || {};
        if (data && data.length > 0 && status === 200) {
          let deptList =
            data.filter((dept) => dept.divnDeptDesc !== "UNKNOWN") || [];
          deptList.sort((dept1, dept2) => {
            if (dept1.deptNbr < dept2.deptNbr) {
              return -1;
            }
            if (dept1.deptNbr > dept2.deptNbr) {
              return 1;
            }
            return 0;
          });

          switch (selectedOpDiv) {
            case `BLOOMINGDALE'S`:
              setDvnDetails((state) => ({
                ...state,
                deptByBloomingdales: deptList,
              }));
              break;
            case "BLOOMINGDALES OUTLET":
              setDvnDetails((state) => ({
                ...state,
                deptByBloomingdalesOutlet: deptList,
              }));
              break;
            case `MACY'S`:
              setDvnDetails((state) => ({
                ...state,
                deptByMacys: deptList,
              }));
              break;
            case `MACY'S BACKSTAGE`:
              setDvnDetails((state) => ({
                ...state,
                deptByMacysBackstage: deptList,
              }));
              break;
            default:
              break;
          }
        }

        setIsEmpltyHierarchy(false);
      });
    }
    if (event && index >= 0) {
      addHierarchyValue(event, index);
    }
  };

  const getGetVendorNumberByDeptNumAndDuns = (hierarchyArr) => {
    hierarchyArr.forEach((item, index) => {
      const division = item.operatingDivision;
      const dept = item.dept;

      if (division && dept) {
        httpGetVendorNumberByDeptNumAndDuns(duns, division, dept).then(
          (res) => {
            setDvnDetails((state) => ({
              ...state,
              vendorNumberByDept: {
                ...state.vendorNumberByDept,
                [index]: res.data.sort((a, b) => {
                  if (a < b) {
                    return -1;
                  }
                  if (a > b) {
                    return 1;
                  }
                  // a must be equal to b
                  return 0;
                }),
              },
            }));
          }
        );
      }
    });
  };

  const addHierarchyValue = (e, index, eventName) => {
    let list = [...hierarchyArr];

    if (eventName === "vendorNumber") {
      let value = e.target.value;
      list[index] = {
        ...list[index],
        vendorNumber: value,
        brandName: null,
        needDvnAudit: value === "0",
        auditApprovedBy: null,
        auditApprovedDate: null,
        wasDvnAudited: false,
        internationalShippingAllowed:
          value !== "0" ? null : list[index].internationalShippingAllowed,
        isNewBrand: value !== "0" ? null : list[index].isNewBrand,
      };
    } else if (eventName === "dvnDeptNumber") {
      const { name, value } = e.target;

      const operatingDivision = list[index]["operatingDivision"];

      const deptList =
        operatingDivision === `BLOOMINGDALE'S`
          ? deptByBloomingdales
          : operatingDivision === "BLOOMINGDALES OUTLET"
          ? deptByBloomingdalesOutlet
          : operatingDivision === `MACY'S`
          ? deptByMacys
          : operatingDivision === `MACY'S BACKSTAGE`
          ? deptByMacysBackstage
          : [];

      const selectedDepartmentNumber =
        deptList.find((dept) => dept.deptNbr === parseInt(value, 10)) || {};

      list[index] = {
        ...list[index],
        [name]: value,
        gmmName:
          selectedDepartmentNumber &&
          Object.keys(selectedDepartmentNumber).length !== 0
            ? selectedDepartmentNumber.gmmId +
              " - " +
              selectedDepartmentNumber.gmmDesc
            : "",
        divisionName:
          selectedDepartmentNumber &&
          Object.keys(selectedDepartmentNumber).length !== 0
            ? selectedDepartmentNumber.divManId +
              " - " +
              selectedDepartmentNumber.divManDesc
            : "",
        vendorNumber: "",
        brandName: null,
        terms: null,
        termsDays: null,
        freightCode: null,
        internationalShippingAllowed: null,
        isNewBrand: null,
        programTypes: null,
        returnDisposition: null,
        salvageAllowance: 0,
        receiptAllowance: 0,
      };
    } else {
      const { name, value } = e.target;

      list[index] = {
        ...list[index],
        [name]: value,
        dept: "",
        vendorNumber: "",
        brandName: null,
        terms: null,
        termsDays: null,
        freightCode: null,
        internationalShippingAllowed: null,
        isNewBrand: null,
        programTypes: null,
        returnDisposition: null,
        salvageAllowance: 0,
        receiptAllowance: 0,
      };
    }
    setDvnDetails((state) => ({
      ...state,
      hierarchyArr: [...list],
      hasDuplicateHierarchyEntry: false,
      dvnUpdateStatus: {
        error: "",
        success: "",
      },
    }));
    viewOnMerchApproval && merchApprovalStateUpdate([...list]);
  };

  const checkForDuplicateHierarchyEntry = () => {
    let hierarchyList = [...hierarchyArr];
    let hierList = [];

    if (hierarchyList.length > 0) {
      hierarchyList.forEach((item) => {
        let hier = {
          dept: item.dept,
          vendorNumber: item.vendorNumber,
          operatingDivision: item.operatingDivision,
        };

        if (item.vendorNumber !== "0" && item.vendorNumber !== "")
          hierList.push(hier);
      });
    }
    if (hierList.length > 0) {
      let hierArrSerialized = hierList.map((x) => JSON.stringify(x));
      let hierSetSerialized = new Set(hierArrSerialized);
      let hierUniqueArrSerialized = [...hierSetSerialized];
      let hierUniqueArrList = hierUniqueArrSerialized.map((x) => JSON.parse(x));

      if (hierUniqueArrList.length !== hierList.length) {
        hierarchyHasDuplicate && hierarchyHasDuplicate(true);
        setDvnDetails((state) => ({
          ...state,
          hasDuplicateHierarchyEntry: true,
        }));
      } else {
        hierarchyHasDuplicate && hierarchyHasDuplicate(false);
        setDvnDetails((state) => ({
          ...state,
          hasDuplicateHierarchyEntry: false,
        }));
      }
    }
  };

  const checkIfButtonShouldBeDisabled = () => {
    let hierarchyList = [...hierarchyArr];

    if (hierarchyList && hierarchyList.length > 0) {
      let shouldApproveButtonDisabled = false;

      hierarchyList.forEach((item) => {
        if (
          item.dept === "" ||
          item.operatingDivision === "" ||
          item.vendorNumber === ""
        ) {
          shouldApproveButtonDisabled = true;
        }
      });

      const shouldAssignNewDVNButtonDisabled =
        hierarchyList &&
        hierarchyList?.length > 0 &&
        hierarchyList.some((item) => item.vendorNumber === "0");

      setDvnDetails((state) => ({
        ...state,
        disableApproveButton: shouldApproveButtonDisabled,
        disableAssignNewDVNsButton:
          shouldApproveButtonDisabled || !shouldAssignNewDVNButtonDisabled,
      }));
    }
  };

  const updateVendorProfileInfo = async (fetchVendorProfile = false) => {
    const vendorProfileInfo = await httpGetVendorProfileById(vendorProfileId);
    setDvnDetails((state) => ({
      ...state,
      hierarchyArr: [...vendorProfileInfo.data?.vendorDetail?.hierarchyDetails],
    }));
    const { vendorDetail = {} } = vendorProfileInfo?.data;
    dispatch(updateServiceData({ vendorDetail }));
  };

  const refreshDataInStore = async (fetchVendorProfile = false) => {
    const vendorStatus = await httpGetVendorStatusDetails(vendorProfileId);

    // Refresh vendor profile if DVN setup is in Error or Complete status
    let serviceData = {
      vendorStatus: vendorStatus.data,
    };
    let commonData = {};
    if (
      fetchVendorProfile &&
      vendorStatus.data &&
      vendorStatus.data.length > 0
    ) {
      const vendorProfileInfo = await httpGetVendorProfileById(vendorProfileId);
      serviceData = {
        ...serviceData,
        vendorProfile: vendorProfileInfo.data,
      };
      commonData = {
        ...commonData,
        duns: vendorProfileInfo.data?.vendorDetail?.duns,
      };
    }

    const { mutatedVendorStatus } = extractVendorStatus(
      vendorDetails.status,
      vendorStatus.data
    );

    commonData = {
      ...commonData,
      boardingStatuses: mutatedVendorStatus,
    };

    //update vendorStatus in service data
    dispatch(updateServiceData(serviceData));
    //update vendorstatus in common slice
    dispatch(updateCommonInfo(commonData));
  };

  const dvnSetupUpdate = (data) => {
    setDvnDetails((state) => ({
      ...state,
      dvnUpdateStatus: {
        error: "",
        success: "",
      },
      disableApproveButton: true,
    }));
    data.duns = duns;

    httpPostSaveVendorStatusByProfileId({
      vendorStatus: data,
      statusName: _.DVN_SET_UP_ID,
      comments: data.comments,
      hierarchy: data.hierarchy,
      //SVH-2038 add to get current user email to set lastupdatedby field
      userEmail: Cookie.get("email") ? Cookie.get("email").toLowerCase() : "",
    })
      .then((res) => {
        if (res && res.status === 200) {
          //update setUpDvn status as approved in common slice
          //update uploadDocuments status as approved in common slice
          try {
            refreshDataInStore(true);

            //update duns in common slice
            dispatch(updateCommonInfo({ duns: duns }));
          } catch (err) {
            setDvnDetails((state) => ({
              ...state,
              dvnUpdateStatus: {
                ...state.dvnUpdateStatus,
                error: _.SERVER_ERROR_MSG,
              },
            }));
          }

          localStorage.setItem("duns", res.data.duns);

          setDvnDetails((state) => ({
            ...state,
            dvnUpdateStatus: {
              ...state.dvnUpdateStatus,
              success: _.DVN_SETUP_MSG.DVN_SETUP_UPDATED,
            },
          }));
        } else {
          setDvnDetails((state) => ({
            ...state,
            dvnUpdateStatus: {
              ...state.dvnUpdateStatus,
              error: _.SERVER_ERROR_MSG,
            },
            disableApproveButton: false,
          }));
        }
      })
      .catch((err) => {
        if (
          err.response &&
          err.response.status === 404 &&
          err.response.data?.messageId === 811
        ) {
          refreshDataInStore();
          dispatch(
            updateVendorProfileDetails({
              hierarchyDetails: data.hierarchy,
              duns: duns,
            })
          );

          //update duns in common slice
          dispatch(updateCommonInfo({ duns: duns }));
        }
        const errorMessage =
          err.response && err.response.data && err.response.data.message
            ? err.response.data.message
            : _.DVN_SETUP_MSG.DVN_SETUP_ERROR_MSG;
        setDvnDetails((state) => ({
          ...state,
          dvnUpdateStatus: {
            ...state.dvnUpdateStatus,
            error: errorMessage,
          },
          disableApproveButton: false,
        }));
      });
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    //update local state to maintain sorted order
    if (hierarchyArr && hierarchyArr.length > 0) {
      let unsortedHierarchy = [...hierarchyArr];
      let sortedAierarchy = getSortedArrayBasedOnVendorNumber(
        unsortedHierarchy
      );
      setDvnDetails((state) => ({
        ...state,
        hierarchyArr: [...sortedAierarchy],
      }));
    }

    let profile = { ...vendorDetails };
    profile.hierarchyDetails = hierarchyArr ? hierarchyArr : null;
    profile.hierarchy = hierarchyArr ? hierarchyArr : null;
    profile.vendorId = vendorProfileId;
    profile.id = null; //Since backend is expecting this id to be null as vendor status table already has an id for dvnSetup Process
    profile.lastStatusUpdatedBy = Cookie.get("email").toLowerCase(); // updating an email id in VendorStatus
    profile.comments = "";
    profile.lastStatusUpdatedValue = _.APPROVED;
    dvnSetupUpdate(profile);
  };

  const removeClick = (e, index) => {
    e.preventDefault();

    let list = [...hierarchyArr];

    resetDVNUpdateStatus();

    list.splice(index, 1);
    setDvnDetails((state) => ({
      ...state,
      hierarchyArr: [...list],
    }));
    viewOnMerchApproval && merchApprovalStateUpdate([...list]);
  };

  const addClick = () => {
    let hierarchyList = [...hierarchyArr];
    let hierarchyListObj = {
      dept: "",
      divisionName: "",
      gmmName: "",
      isPrimary: false,
      isOperDivPrimary: false,
      operatingDivision: "",
      vendorNumber: "",
      vendorProfileId: vendorProfileId,
      brandName: null,
      terms: null,
      termsDays: null,
      freightCode: null,
      internationalShippingAllowed: null,
      isNewBrand: null,
      returnDisposition: null,
      salvageAllowance: 0,
      receiptAllowance: 0,
    };

    resetDVNUpdateStatus();

    hierarchyList.push(hierarchyListObj);
    setDvnDetails((state) => ({
      ...state,
      hierarchyArr: [...hierarchyList],
    }));

    viewOnMerchApproval && merchApprovalStateUpdate([...hierarchyList]);
  };

  const resetDVNUpdateStatus = () => {
    if (dvnUpdateStatus.error || dvnUpdateStatus.success) {
      setDvnDetails((state) => ({
        ...state,
        dvnUpdateStatus: {
          error: "",
          success: "",
        },
      }));
    }
  };

  const onChangeDunsNumber = (key, e) => {
    parentStatusMsgRefreshHandler && parentStatusMsgRefreshHandler();
    setDunValidationMsg("");
    setDunValidationErrorMsg("");
    setDvnDetails((state) => ({
      ...state,
      dvnUpdateStatus: {
        error: "",
        success: "",
      },
    }));

    if (e.target.value.length == 0) {
      //Make the existing vendor number selection reset
      clearAllexistingVendorNumberSelection();
      setDvnDetails((state) => ({
        ...state,
        vendorNumberByDept: {},
      }));

      setIsDunsValidated(true);
      dunsValidatorHandler && dunsValidatorHandler({ isDunsValidated: true });
      setHasErrorIndex(-1);
      setIsValidDunsNumber(true);
      setIsOnChangeVaildDuns(true);
      setDvnDetails((state) => ({
        ...state,
        disableApproveButton: false,
      }));
    } else {
      if (Validations.isValidDuns(e.target.value)) {
        setIsValidDunsNumber(true);
        setIsOnChangeVaildDuns(true);
        setHasErrorIndex(-1);
      } else {
        setHasErrorIndex(13);
        setIsValidDunsNumber(false);
        setDunValidationErrorMsg(Constants.DUNS_VALIDATION_ERROR_MSG);
      }

      setIsDunsValidated(false);
      dunsValidatorHandler && dunsValidatorHandler({ isDunsValidated: false });
    }

    setDuns(e.target.value);
    viewOnMerchApproval &&
      dunsValidatorHandler({ isDunsPresent: false, dunsExists: false });
    viewOnMerchApproval && merchApprovalStateUpdate(null, e.target.value);

    if (
      e.target.value === "" &&
      hierarchyArr.some((item) => item.vendorNumber === "0")
    ) {
      setDvnDetails((state) => ({
        ...state,
        disableAssignNewDVNsButton: false,
      }));
    } else if (hierarchyArr.some((item) => item.vendorNumber === "0")) {
      setDvnDetails((state) => ({
        ...state,
        disableAssignNewDVNsButton: false,
      }));
    } else {
      setDvnDetails((state) => ({
        ...state,
        disableAssignNewDVNsButton: true,
      }));
    }
  };

  const validateDunsAlreadyExist = () => {
    if (Validations.isValidDuns(duns) && store.userEmail) {
      //Given duns is in proper format hence prepare to call the api
      setIsValidDunsNumber(true);

      const vendorDetail = store.vendorDetails;
      var encodeUserEmail = encodeURIComponent(store.userEmail);

      //CorpName will be "MERCH" if it is being called from Merchant Approval page
      //CorpName will be "DVNSETUP" if it is being called from DVN Setup page
      var encodeCorpNm = "";
      if (viewOnMerchApproval) {
        encodeCorpNm = Constants.MERCH;
      } else {
        encodeCorpNm = Constants.DVNSETUP;
      }

      var isPrimaryVendor =
        vendorDetail?.isPrimaryVendor === undefined ||
        vendorDetail?.isPrimaryVendor
          ? true
          : false;

      axios()
        .get(
          `/vendorProfile/validateDunsAndCorpName?duns=${duns}&corpName=${encodeCorpNm}&email=${encodeUserEmail}&isPrimaryVendor=${isPrimaryVendor}`
        )
        .then((res) => {
          if (res && res.data) {
            const ifOwnVendorProfile = res.data.ownVendorProfile;
            const ifVendorPresent = res.data.vendorPresent;

            setIsOwnVendorProfile(ifOwnVendorProfile);
            setIsVendorPresent(ifVendorPresent);

            setIsOnChangeVaildDuns(false);
            clearAllexistingVendorNumberSelection();

            if (
              (ifOwnVendorProfile === false && ifVendorPresent === false) ||
              ifOwnVendorProfile === true ||
              ifVendorPresent === false
            ) {
              if (viewOnMerchApproval) {
                dunsValidatorHandler &&
                  dunsValidatorHandler({
                    isDunsPresent: false,
                    dunsExists: false,
                  });
              }

              setDunValidationMsg(Constants.DUNS_VALIDATION_SUCCESS_MSG);
            } else {
              if (viewOnMerchApproval) {
                dunsValidatorHandler &&
                  dunsValidatorHandler({
                    isDunsPresent: true,
                    dunsExists: true,
                  });
              }
            }

            setIsDunsValidated(true);
            dunsValidatorHandler &&
              dunsValidatorHandler({ isDunsValidated: true });

            if (ifOwnVendorProfile) {
              setDvnDetails((state) => ({
                ...state,
                disableApproveButton: false,
              }));
            } else {
              setDvnDetails((state) => ({
                ...state,
                disableApproveButton: true,
              }));
            }
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }
  };

  const clearAllexistingVendorNumberSelection = () => {
    let list = [...hierarchyArr];
    let updatedList = [];
    if (list && list.length > 0) {
      updatedList = list.map((x) => ({
        ...x,
        vendorNumber: "",
      }));
    }

    setDvnDetails((state) => ({
      ...state,
      hierarchyArr: [...updatedList],
    }));
    viewOnMerchApproval && merchApprovalStateUpdate([...updatedList]);
  };

  const getVendorNumber = (hierarchyItem, availableVendorList, index) => {
    let vendorNumber = hierarchyItem.vendorNumber;
    let vendorList = availableVendorList[`${index}`];

    if (vendorNumber === "0") return "0";
    if (vendorNumber && vendorList) {
      if (vendorList.includes(parseInt(vendorNumber))) {
        return vendorNumber;
      } else {
        return "";
      }
    }
    return "";
  };

  const getApproveButtonDisabledStatus = () => {
    if (
      (onboardingStatus !== "" &&
        checkOnBoardingStatus(onboardingStatus, [
          _.MERCHANT_APPROVED,
          _.VENDOR_REGISTRATION,
          _.VENDOR_SUBMISSION,
        ])) ||
      !(vendorProfileDetails && vendorProfileDetails.status === _.APPROVED) ||
      disableApproveButton ||
      !disableAssignNewDVNsButton ||
      !(rolePermissionForApproveButton === rolePermConsts.EDIT) ||
      !isValidDuns(vendorDetails.duns) ||
      hasDuplicateHierarchyEntry ||
      dvnDetails.dvnSetupStatus === Constants.DVN_SETUP_STATUS_PENDING ||
      !isDunsValidated
    ) {
      return true;
    } else {
      return false;
    }
  };

  const handleAssignNewDVNsDuns = (event) => {
    event.preventDefault();

    setDvnDetails((state) => ({
      ...state,
      dvnUpdateStatus: {
        error: "",
        success: "",
      },
      disableAssignNewDVNsButton: true,
      disableApproveButton: true,
      disableViewModifyButton: true,
    }));

    const { id, brandName = "" } = vendorDetails || {};
    let newDVNsDunsPayload = {};

    if (hierarchyArr && hierarchyArr.length > 0) {
      let unsortedHierarchy = [
        ...hierarchyArr.map((item) => {
          return {
            ...item,
            dvnRequestedBy:
              item?.vendorNumber?.toString() === "0"
                ? Cookie.get("email")
                : item?.dvnRequestedBy,
          };
        }),
      ];
      let sortedAierarchy = getSortedArrayBasedOnVendorNumber(
        unsortedHierarchy
      );
      newDVNsDunsPayload.hierarchy = sortedAierarchy;
    }

    newDVNsDunsPayload.userName = Cookie.get("userName");
    newDVNsDunsPayload.userEmail = Cookie.get("email").toLowerCase();
    newDVNsDunsPayload.vendorProfileId = id;
    newDVNsDunsPayload.duns = duns;
    newDVNsDunsPayload.brandName = brandName;

    httpPostRequestNewDVN(newDVNsDunsPayload)
      .then(async (res) => {
        if (res?.status === 200) {
          try {
            await refreshDataInStore(true);
            setDvnDetails((state) => ({
              ...state,
              disableViewModifyButton: false,
            }));
          } catch (err) {
            setDvnDetails((state) => ({
              ...state,
              dvnUpdateStatus: {
                ...state.dvnUpdateStatus,
                error: _.SERVER_ERROR_MSG,
              },
              disableViewModifyButton: false,
            }));
          }

          localStorage.setItem("duns", newDVNsDunsPayload.duns);
        } else {
          setDvnDetails((state) => ({
            ...state,
            dvnUpdateStatus: {
              ...state.dvnUpdateStatus,
              error: _.SERVER_ERROR_MSG,
            },
            disableAssignNewDVNsButton: false,
            disableViewModifyButton: false,
          }));
        }
      })
      .catch(async (err) => {
        try {
          await refreshDataInStore(true);
        } catch (err) {
          console.log(err);
        }
        const errorMessage =
          err?.response?.data?.message !== ""
            ? err?.response?.data?.message
            : _.DVN_SETUP_MSG.DVN_SETUP_ERROR_MSG;
        setDvnDetails((state) => ({
          ...state,
          dvnUpdateStatus: {
            ...state.dvnUpdateStatus,
            error: errorMessage,
          },
          disableAssignNewDVNsButton: false,
          refreshDataInStore: false,
        }));
      });
  };

  const ifDunsDisabledForMerchantApprovalPage = () => {
    if (
      viewOnMerchApproval &&
      (onboardingStatus === Constants.ACCOUNTS_PAYABLE_APPROVED ||
        checkIfVendorReturnedToMerchant())
    ) {
      return true;
    }
    return false;
  };

  const checkIfVendorReturnedToMerchant = () => {
    if (
      onboardingStatus === Constants.VENDOR_SUBMISSION &&
      checkIfReturnToMerchantNotePresent()
    ) {
      return true;
    }
    return false;
  };

  const handleSave = () => {
    let payLoad = {};
    payLoad.hierarchyList = hierarchyArr.map((item) => {
      return {
        ...item,
        duns: duns || "",
        dvnRequestedBy: item.dvnRequestedBy
          ? item.dvnRequestedBy
          : Cookie.get("email"),
      };
    });
    payLoad.activity = "viewmodify";

    httpPostHirarchySave(payLoad)
      .then((res) => {
        if (res && res.data) {
          if (res.status === 200) {
            dispatch(
              updateVendorProfileDetails({
                hierarchyDetails: res.data.hierarchyDetails
                  ? res.data.hierarchyDetails
                  : hierarchyArr,
              })
            );

            dispatch(updateCommonInfo({ duns }));
            history.push({
              pathname: `/boarding/vendor/dvnbrand/dvnsetup/${store.profileId}`,
              param: "dvnbrand",
              state: { detail: dvnDetails },
            });
          }
        }
      })
      .catch((err) => {
        setValidationErrorMessage(err.message);
      });
  };

  const navigateBrand = (e) => {
    const dvnData = {
      detail: {
        ...dvnDetails,
        vendorDetails: {
          ...dvnDetails.vendorDetails,
          hierarchyDetails: dvnDetails?.vendorDetails?.hierarchyDetails?.map(
            (item) => {
              return {
                ...item,
                dvnRequestedBy: item.dvnRequestedBy
                  ? item.dvnRequestedBy
                  : Cookie.get("email"),
              };
            }
          ),
        },
        hierarchyArr: dvnDetails?.hierarchyArr?.map((item) => {
          return {
            ...item,
            dvnRequestedBy: item.dvnRequestedBy
              ? item.dvnRequestedBy
              : Cookie.get("email"),
          };
        }),
      },
    };

    if (viewOnMerchApproval) {
      submitMerchantContactApproval(e, true, dvnData, viewOnMerchApproval);
    } else {
      handleSave();
    }
  };

  //Below is to check if the onboardingStatus is vendor submission due to return back to merchnat
  const checkIfReturnToMerchantNotePresent = () => {
    let notes = store.notes;
    if (
      notes &&
      notes.length > 0 &&
      notes[0].noteType?.trim().toLowerCase() ===
        Constants.ACTION_OPTIONS_RETURN_TO_MERCHANT_LABEL.toLowerCase()
    ) {
      return true;
    }
    return false;
  };

  const disableForMerch = () =>
    viewOnMerchApproval &&
    _.disableHierarchyStatuses.includes(onboardingStatus);

  const checkIfAddButtonShouldBeDisabled = () => {
    if (viewOnMerchApproval) {
      if (
        ifDunsDisabledForMerchantApprovalPage() ||
        !(rolePermissionForAddButton_MA === rolePermConsts.EDIT)
      ) {
        return true;
      }
    } else {
      if (
        (onboardingStatus !== "" &&
          checkOnBoardingStatus(onboardingStatus, [
            _.MERCHANT_APPROVED,
            _.VENDOR_REGISTRATION,
            _.VENDOR_SUBMISSION,
          ])) ||
        !(vendorProfileDetails && vendorProfileDetails.status === _.APPROVED) ||
        !(rolePermissionForAddButton === rolePermConsts.EDIT)
      ) {
        return true;
      }
    }

    return false;
  };
  const checkIfAddButtonShouldHide = () => {
    return !(
      checkIfAddButtonShouldBeDisabled() ||
      (!viewOnMerchApproval &&
        dvnDetails.dvnSetupStatus === Constants.DVN_SETUP_STATUS_PENDING)
    );
  };

  const checkIfRemoveButtonShouldBeDisabled = () => {
    if (viewOnMerchApproval) {
      if (
        ifDunsDisabledForMerchantApprovalPage() ||
        !(rolePermissionForRemoveButton_MA === rolePermConsts.EDIT)
      ) {
        return true;
      }
    } else {
      if (
        (onboardingStatus !== "" &&
          checkOnBoardingStatus(onboardingStatus, [
            _.MERCHANT_APPROVED,
            _.VENDOR_REGISTRATION,
            _.VENDOR_SUBMISSION,
          ])) ||
        !(vendorProfileDetails && vendorProfileDetails.status === _.APPROVED) ||
        !(rolePermissionForRemoveButton === rolePermConsts.EDIT)
      ) {
        return true;
      }
    }
    return false;
  };
  const checkIfRemoveButtonShouldHide = () => {
    return !(
      checkIfRemoveButtonShouldBeDisabled() ||
      (!viewOnMerchApproval &&
        dvnDetails.dvnSetupStatus === Constants.DVN_SETUP_STATUS_PENDING)
    );
  };

  const checkIfDunsRevalidateAreaShouldBeDisabled = () => {
    if (viewOnMerchApproval) {
      if (
        parentAccessDisabled ||
        disableForMerch() ||
        vendorDetails.isPrimaryVendor === false ||
        ifDunsDisabledForMerchantApprovalPage() ||
        !(rolePermissionForReValidateButton_MA === rolePermConsts.EDIT)
      ) {
        return true;
      }
    } else {
      if (
        (onboardingStatus !== "" &&
          checkOnBoardingStatus(onboardingStatus, [
            _.MERCHANT_APPROVED,
            _.VENDOR_REGISTRATION,
            _.VENDOR_SUBMISSION,
          ])) ||
        !(vendorProfileDetails && vendorProfileDetails.status === _.APPROVED) ||
        !(rolePermissionForEntireDVNPage === rolePermConsts.EDIT) ||
        !(rolePermissionForReValidateButton === rolePermConsts.EDIT) ||
        vendorDetails.isPrimaryVendor === false
      ) {
        return true;
      }
    }
    return false;
  };

  const checkIfHierarchyAreaShouldBeDisabled = () => {
    if (viewOnMerchApproval) {
      if (
        parentAccessDisabled ||
        disableForMerch() ||
        ifDunsDisabledForMerchantApprovalPage() ||
        !(rolePermissionForHierarchySelection_MA === rolePermConsts.EDIT)
      ) {
        return true;
      }
    } else {
      if (
        (onboardingStatus !== "" &&
          checkOnBoardingStatus(onboardingStatus, [
            _.MERCHANT_APPROVED,
            _.VENDOR_REGISTRATION,
            _.VENDOR_SUBMISSION,
          ])) ||
        !(vendorProfileDetails && vendorProfileDetails.status === _.APPROVED) ||
        !(rolePermissionForHierarchySelection === rolePermConsts.EDIT)
      ) {
        return true;
      }
    }
    return false;
  };

  const checkPageLevelViewAccess = () => {
    if (viewOnMerchApproval) {
      if (
        rolePermissionForEntireDVNPage_MA === rolePermConsts.VIEW ||
        parentAccessDisabled
      ) {
        return true;
      }
    } else {
      if (rolePermissionForEntireDVNPage === rolePermConsts.VIEW) {
        return true;
      }
    }

    return false;
  };

  const checkPageLevelEditAccess = () => {
    if (viewOnMerchApproval) {
      if (
        rolePermissionForEntireDVNPage_MA === rolePermConsts.EDIT &&
        !parentAccessDisabled
      ) {
        return true;
      }
    } else {
      if (rolePermissionForEntireDVNPage === rolePermConsts.EDIT) {
        return true;
      }
    }

    return false;
  };

  const reValidateBtn = () => {
    const roleVal = viewOnMerchApproval
      ? rolePermConsts.VENDORPLATFORM_COMPANYINFORMATION_MERCHANTAPPROVAL
      : rolePermConsts.VENDORPLATFORM_PREBOARDING_DVNSETUP;
    return (
      getUserRolePermission(roleVal, rolePermConsts.VMP_REVALIDATE) !==
      rolePermConsts.NONE
    );
  };

  const disableIsVendorNumber = (vendorNumb) => {
    let flagToDisable = true;

    if (vendorNumb === "0" || vendorNumb === "") flagToDisable = false;
    return flagToDisable;
  };

  const handleMainframeActionRequired = () => {
    const filteredHeirarchy = hierarchyArr.filter(
      (item) => item.vendorNumber !== "0"
    );

    const data = {
      userName: Cookie.get("userName"),
      userEmail: encodeURIComponent(store.userEmail),
      vendorProfileId: store.vendorProfile?.vendorDetail?.id,
      hierarchy: filteredHeirarchy,
    };

    httpPostMainframeSuffixError(data)
      .then((res) => {
        setActionRequiredMainframe(false);
        updateVendorProfileInfo(store.vendorProfile?.vendorDetail?.id);
        refreshDataAfterActionSuccessful();
        setSuffixErrorMessage("");
        setSuffixErrorMessageFlag(false);
      })
      .catch((err) => {
        setActionRequiredMainframe(true);
        setSuffixErrorMessage(
          Constants.DVN_CONSIGNMENT_SUFFIX_API_FAILURE_MESSAGE
        );
        setSuffixErrorMessageFlag(true);
      });
  };

  const getDvnSetupErrorFlag = () => {
    return (
      rolePermissionForActionRequiredFromMainframeMsgView &&
      actionRequiredMainframe &&
      dvnDetails.dvnSetupStatus === Constants.DVN_SETUP_STATUS_ERROR
    );
  };
  const isDvnSetupErrorFlag = getDvnSetupErrorFlag();

  return (
    <>
      {errorModal && getShowErrorMessages()}
      <p className="validationErrorMsg" style={{ marginLeft: "20px" }}>
        {validationErrorMessage}
      </p>
      {suffixErrorMessageFlag && (
        <p className="validationErrorMsg" style={{ marginLeft: "20px" }}>
          {suffixErrorMessage}
        </p>
      )}

      <Row>
        <Col md={12}>
          {!viewOnMerchApproval &&
          rolePermissionForEntireDVNPage === rolePermConsts.NONE ? (
            <DisplayStatus
              msg={rolePermConsts.VMP_DVNSETUP_PAGE_ACCESS_ERROR_MSG}
              status="error"
            />
          ) : (
            <>
              {!viewOnMerchApproval && (
                <div className="col-md-12 p-0">
                  {(dvnDetails.dvnSetupStatus ===
                    Constants.DVN_SETUP_STATUS_PENDING ||
                    dvnDetails.dvnSetupStatus ===
                      Constants.DVN_SETUP_STATUS_COMPLETE) && (
                    <ErrorContainer
                      updateStatus={true}
                      successMsg={dvnDetails.dvnSetupStatusMsg}
                      successStyle="successMessage"
                    />
                  )}
                  {dvnDetails.dvnSetupStatus ===
                    Constants.DVN_SETUP_STATUS_ERROR && (
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <ErrorContainer
                        errorMsg={dvnDetails.dvnSetupStatusMsg}
                        errorStatus={true}
                        errorStyle="errorMessage"
                      />
                      <Button
                        id="dvnSetupErrorBtn"
                        size="md"
                        className="button-primary-md"
                        onClick={() => handleErrorBtn()}
                      >
                        {Constants.DVN_SETUP_STATUS_ERROR_BTN}
                      </Button>
                    </div>
                  )}
                </div>
              )}
              <div className="m-top-10 dvnsetup-container">
                {dvnUpdateStatus.success && (
                  <DisplayStatus
                    msg={dvnUpdateStatus.success}
                    status="success"
                  />
                )}
                {dvnUpdateStatus.error && (
                  <DisplayStatus msg={dvnUpdateStatus.error} status="error" />
                )}
                <div className="m-top-n20">
                  {dvnDetails.vendorDetails && (
                    <Form name="DvnForm">
                      <Form.Row
                        key="dvnDuns"
                        style={
                          viewOnMerchApproval
                            ? { position: "relative", right: "10px" }
                            : {}
                        }
                      >
                        <DunsWrapper
                          onChange={onChangeDunsNumber}
                          dunsValidationStatus={getDunsValidationStatus()}
                          dunsErrorStatus={getErrorStatus()}
                          dunValidationMsg={dunValidationMsg}
                          dunValidationErrorMsg={dunValidationErrorMsg}
                          dunsErrorMessage={""}
                          duns={duns}
                          type={"duns"}
                          viewOnMerchApproval={viewOnMerchApproval}
                          validateDunsAlreadyExist={validateDunsAlreadyExist}
                          isDunsValidated={isDunsValidated}
                          isValidDunsNumber={isValidDunsNumber}
                          dunsCheckMarkSatus={getDunsCheckMarkSatus()}
                          hasErrorIndex={hasErrorIndex}
                          dunsExistingValue={store.duns}
                          isPrimaryVendor={vendorDetails.isPrimaryVendor}
                          disabled={
                            checkIfDunsRevalidateAreaShouldBeDisabled() ||
                            (!viewOnMerchApproval &&
                              dvnDetails.dvnSetupStatus ===
                                Constants.DVN_SETUP_STATUS_PENDING)
                          }
                          dunsExists={merchApprovalStateUpdate && dunsExists}
                          reValidateFlag={reValidateBtn}
                        />
                      </Form.Row>

                      {checkPageLevelViewAccess() && (
                        <>
                          {hierarchyArr.length > 0 ? (
                            <>
                              <Form.Row
                                key="view_header_dvn"
                                className={
                                  viewOnMerchApproval ? "ml-0" : "ml-2"
                                }
                              >
                                <Col md={2}>
                                  <Form.Label className="font-weight-bold">
                                    Operating Division
                                  </Form.Label>
                                </Col>
                                <Col md={3}>
                                  <Form.Label className="font-weight-bold">
                                    Department Number
                                  </Form.Label>
                                </Col>
                                <Col md={3}>
                                  <Form.Label className="font-weight-bold">
                                    Vendor Number
                                  </Form.Label>
                                </Col>
                              </Form.Row>
                              {hierarchyArr.map((item, index) => (
                                <Form.Row
                                  key={"primaryDVNS_view_row" + index}
                                  className={
                                    viewOnMerchApproval ? "ml-0" : "ml-2"
                                  }
                                >
                                  <Form.Group as={Col} md={2}>
                                    <Form.Control
                                      id={"dvnOperDiv" + index}
                                      defaultValue={
                                        item && item.operatingDivision
                                      }
                                      disabled
                                    />
                                  </Form.Group>
                                  <Form.Group as={Col} md={3}>
                                    <Form.Control
                                      id={"dvnDeptNumber" + index}
                                      defaultValue={item && item.dept}
                                      disabled
                                    />
                                  </Form.Group>
                                  <Form.Group as={Col} md={3}>
                                    <Form.Control
                                      id={"dvnVendNumber" + index}
                                      defaultValue={item && item.vendorNumber}
                                      disabled
                                    />
                                  </Form.Group>
                                </Form.Row>
                              ))}
                            </>
                          ) : (
                            <span>
                              No Department and Vendor number available.
                            </span>
                          )}
                        </>
                      )}
                      {checkPageLevelEditAccess() && (
                        <>
                          <Form.Row
                            key="edit_dvn_header"
                            className={viewOnMerchApproval ? "ml-0" : "ml-2"}
                          >
                            <Col md={2}>
                              <Form.Label className="font-weight-bold">
                                Operating Division
                                {viewOnMerchApproval && (
                                  <>
                                    &nbsp;
                                    <span className={Constants.REQUIRED}>
                                      *
                                    </span>
                                  </>
                                )}
                              </Form.Label>
                            </Col>
                            <Col md={viewOnMerchApproval ? 2 : 3}>
                              <Form.Label className="font-weight-bold">
                                Department Number
                                {viewOnMerchApproval && (
                                  <>
                                    &nbsp;
                                    <span className={Constants.REQUIRED}>
                                      *
                                    </span>
                                  </>
                                )}
                              </Form.Label>
                            </Col>
                            <Col md={2}>
                              <Form.Label className="font-weight-bold">
                                Vendor Number
                                {viewOnMerchApproval && (
                                  <>
                                    &nbsp;
                                    <span className={Constants.REQUIRED}>
                                      *
                                    </span>
                                  </>
                                )}
                              </Form.Label>
                            </Col>
                          </Form.Row>
                          {hierarchyArr.map((item, index) => (
                            <Form.Row
                              key={"primaryDVN_edit_formRow" + index}
                              className={viewOnMerchApproval ? "ml-0" : "ml-2"}
                            >
                              <Form.Group as={Col} md={2}>
                                <FormControl
                                  as="select"
                                  name="operatingDivision"
                                  defaultValue={
                                    item ? item.operatingDivision : _.SELECT_ONE
                                  }
                                  value={
                                    item ? item.operatingDivision : _.SELECT_ONE
                                  }
                                  onChange={(event) => {
                                    setChangedField("operatingDivision");
                                    getDeptByOperatingDivision(
                                      event.target.value,
                                      event,
                                      index
                                    );
                                  }}
                                  disabled={
                                    checkIfHierarchyAreaShouldBeDisabled() ||
                                    (!viewOnMerchApproval &&
                                      dvnDetails.dvnSetupStatus ===
                                        Constants.DVN_SETUP_STATUS_PENDING)
                                  }
                                >
                                  <option value="" selected hidden>
                                    {_.SELECT_ONE}
                                  </option>
                                  {operatingDivisions.map((option, oi) => (
                                    <option value={option} key={oi}>
                                      {option}
                                    </option>
                                  ))}
                                </FormControl>
                              </Form.Group>
                              <Form.Group
                                key="dvnDeptNumber"
                                as={Col}
                                md={viewOnMerchApproval ? 2 : 3}
                              >
                                <FormControl
                                  as="select"
                                  defaultValue={item ? item.dept : _.SELECT_ONE}
                                  value={
                                    item && item.dept !== "" ? item.dept : ""
                                  }
                                  id="dvnDeptNumber"
                                  name="dept"
                                  onChange={(e) => {
                                    setChangedField("dvnDeptNumber");
                                    addHierarchyValue(
                                      e,
                                      index,
                                      "dvnDeptNumber"
                                    );
                                  }}
                                  disabled={
                                    (item && item.operatingDivision === "") ||
                                    checkIfHierarchyAreaShouldBeDisabled() ||
                                    (!viewOnMerchApproval &&
                                      dvnDetails.dvnSetupStatus ===
                                        Constants.DVN_SETUP_STATUS_PENDING) ||
                                    item.dept > 999
                                  }
                                >
                                  <option value="" selected hidden>
                                    {_.SELECT_ONE}
                                  </option>
                                  {item.operatingDivision === `MACY'S` &&
                                    deptByMacys &&
                                    deptByMacys.length > 0 &&
                                    deptByMacys.map((option, oi) => {
                                      let results = {};
                                      results = (
                                        <option
                                          value={option.deptNbr}
                                          key={oi}
                                          disabled={option.deptNbr > 999}
                                        >
                                          {option.deptNbr} -{" "}
                                          {option.divnDeptDesc}
                                        </option>
                                      );
                                      return results;
                                    })}

                                  {item.operatingDivision ===
                                    `BLOOMINGDALE'S` &&
                                    deptByBloomingdales.length > 0 &&
                                    deptByBloomingdales.map((option, oi) => (
                                      <option
                                        value={option.deptNbr}
                                        key={oi}
                                        disabled={option.deptNbr > 999}
                                      >
                                        {option.deptNbr} - {option.divnDeptDesc}
                                      </option>
                                    ))}

                                  {item.operatingDivision ===
                                    "BLOOMINGDALES OUTLET" &&
                                    deptByBloomingdalesOutlet.length > 0 &&
                                    deptByBloomingdalesOutlet.map(
                                      (option, oi) => (
                                        <option
                                          value={option.deptNbr}
                                          key={oi}
                                          disabled={option.deptNbr > 999}
                                        >
                                          {option.deptNbr} -{" "}
                                          {option.divnDeptDesc}
                                        </option>
                                      )
                                    )}

                                  {item.operatingDivision ===
                                    `MACY'S BACKSTAGE` &&
                                    deptByMacysBackstage.length > 0 &&
                                    deptByMacysBackstage.map((option, oi) => (
                                      <option
                                        value={option.deptNbr}
                                        key={oi}
                                        disabled={option.deptNbr > 999}
                                      >
                                        {option.deptNbr} - {option.divnDeptDesc}
                                      </option>
                                    ))}
                                </FormControl>
                              </Form.Group>
                              <Form.Group as={Col} md={2}>
                                <FormControl
                                  as="select"
                                  defaultValue={
                                    item && item.vendorNumber
                                      ? item.vendorNumber
                                      : ""
                                  }
                                  value={getVendorNumber(
                                    item,
                                    vendorNumberByDept,
                                    index
                                  )}
                                  id="vendorNumber"
                                  name="vendorNumber"
                                  onChange={(e) => {
                                    setChangedField("vendorNumber");
                                    addHierarchyValue(e, index, "vendorNumber");
                                  }}
                                  disabled={
                                    (item && item.dept === "") ||
                                    checkIfHierarchyAreaShouldBeDisabled() ||
                                    (!viewOnMerchApproval &&
                                      dvnDetails.dvnSetupStatus ===
                                        Constants.DVN_SETUP_STATUS_PENDING) ||
                                    disableIsVendorNumber(item?.vendorNumber)
                                  }
                                >
                                  <option value="" selected disabled hidden>
                                    {"SELECT..."}
                                  </option>
                                  <option
                                    value="0"
                                    key={"vendorNumber_defaultOption"}
                                  >
                                    {_.ASSIGN_NEW_DVN}
                                  </option>
                                  {Object.keys(vendorNumberByDept).length > 0 &&
                                    vendorNumberByDept[`${index}`] &&
                                    vendorNumberByDept[`${index}`].map(
                                      (option, oi) => (
                                        <option value={option} key={oi}>
                                          {option}
                                        </option>
                                      )
                                    )}
                                </FormControl>
                              </Form.Group>
                              {!disableForMerch() && (
                                <Form.Group
                                  as={Col}
                                  md={viewOnMerchApproval ? 4 : 3}
                                >
                                  {checkIfRemoveButtonShouldHide() &&
                                    hierarchyArr.length !== 1 && (
                                      <Button
                                        disabled={isDvnSetupErrorFlag}
                                        onClick={(e) => removeClick(e, index)}
                                      >
                                        - Remove
                                      </Button>
                                    )}
                                  {checkIfAddButtonShouldHide() &&
                                    hierarchyArr.length - 1 === index && (
                                      <Button
                                        disabled={isDvnSetupErrorFlag}
                                        onClick={addClick}
                                        style={{ marginLeft: "5px" }}
                                      >
                                        {viewOnMerchApproval
                                          ? "+ Add another row"
                                          : "+ Add"}
                                      </Button>
                                    )}
                                </Form.Group>
                              )}
                            </Form.Row>
                          ))}
                        </>
                      )}
                      <>
                        <Form.Row key="dvn_formRow_submit">
                          <Form.Group
                            as={Col}
                            md={11}
                            className="dvnsetup-approve-button"
                          >
                            <Form.Check
                              type="checkbox"
                              name="brandMappingDVN"
                              id="brandMappingDVN"
                              className={
                                viewOnMerchApproval
                                  ? "dvnsetup-brandmapping-checkbox"
                                  : "dvnsetup-brandmapping-checkbox-notes"
                              }
                            >
                              <Form.Check.Input
                                type="checkbox"
                                disabled={
                                  (!viewOnMerchApproval &&
                                    !(
                                      rolePermissionForBrandMappingCheckbox ===
                                      rolePermConsts.VIEW
                                    )) ||
                                  (viewOnMerchApproval &&
                                    !(
                                      rolePermissionForBrandMappingCheckbox_MA ===
                                      rolePermConsts.VIEW
                                    )) ||
                                  true
                                }
                                checked={hasBrandMapping}
                                onChange={(e) => console.log(e.target.type)}
                              />
                              <Form.Check.Label
                                style={{ color: "black", marginTop: "1%" }}
                              >
                                Brand Mapping and DVN-Level Attributes
                                <span className={Constants.REQUIRED}>*</span>
                              </Form.Check.Label>
                            </Form.Check>
                            <Button
                              id="viewModifyBrandMappingDVN"
                              size="md"
                              className="button-primary-md"
                              style={{ marginRight: "1%" }}
                              onClick={navigateBrand}
                              disabled={
                                (!viewOnMerchApproval &&
                                  !(
                                    rolePermissionForBrandMappingViewModifyButton ===
                                    rolePermConsts.EDIT
                                  )) ||
                                (viewOnMerchApproval &&
                                  !(
                                    rolePermissionForBrandMappingViewModifyButton_MA ===
                                    rolePermConsts.EDIT
                                  )) ||
                                (hierarchyArr?.length > 0 &&
                                  hierarchyArr?.some(
                                    (item) =>
                                      item.operatingDivision === "" ||
                                      item.dept === "" ||
                                      item.vendorNumber === ""
                                  )) ||
                                hasDuplicateHierarchyEntry ||
                                isDvnSetupErrorFlag ||
                                getMerchanteApproveBtnEnable() ||
                                isEmpltyHierarchy ||
                                dvnDetails.dvnSetupStatus ===
                                  Constants.DVN_SETUP_STATUS_PENDING ||
                                dvnDetails.disableViewModifyButton
                              }
                            >
                              {_.VIEW_MODIFY}
                            </Button>
                            {!viewOnMerchApproval && (
                              <>
                                <Button
                                  id="assignNewDVNsDunsBtn"
                                  size="md"
                                  className="btn-primary-assignNewDVNsDuns"
                                  onClick={handleAssignNewDVNsDuns}
                                  disabled={
                                    !hasBrandMapping ||
                                    (onboardingStatus !== "" &&
                                      checkOnBoardingStatus(onboardingStatus, [
                                        _.MERCHANT_APPROVED,
                                        _.VENDOR_REGISTRATION,
                                        _.VENDOR_SUBMISSION,
                                      ])) ||
                                    !(
                                      vendorProfileDetails &&
                                      vendorProfileDetails.status === _.APPROVED
                                    ) ||
                                    isDvnSetupErrorFlag ||
                                    disableAssignNewDVNsButton ||
                                    !(
                                      rolePermissionForAssignNewDVNsAndDuns ===
                                      rolePermConsts.EDIT
                                    ) ||
                                    hasDuplicateHierarchyEntry ||
                                    dvnDetails.dvnSetupStatus ===
                                      Constants.DVN_SETUP_STATUS_PENDING ||
                                    (duns && validateMerchantData()) ||
                                    (store?.documentList?.length > 0 &&
                                      !store?.documentList?.some(
                                        (doc) =>
                                          doc.fileType ===
                                          "BrandMappingTemplate"
                                      ) &&
                                      !store?.mandatoryDocRes
                                        ?.isMandatoryDocumentPresent &&
                                      hierarchyArr?.length > 0 &&
                                      hierarchyArr?.some(
                                        (item) =>
                                          item.brandName ===
                                            Constants.MERCHANT_CLASS_LEVEL_MAPPING &&
                                          item.vendorNumber === "0"
                                      ))
                                  }
                                >
                                  {_.ASSIGN_NEW_DVNS_AND_DUNS}
                                </Button>
                                <Button
                                  id="dvnApproveBtn"
                                  size="md"
                                  className="button-primary-note-md"
                                  onClick={handleSubmit}
                                  disabled={
                                    !hasBrandMapping ||
                                    isDvnSetupErrorFlag ||
                                    getApproveButtonDisabledStatus()
                                  }
                                >
                                  {_.BUTTON_APPROVE}
                                </Button>
                              </>
                            )}
                          </Form.Group>
                        </Form.Row>
                        <Form.Row
                          style={{ justifyContent: "center" }}
                          key="dvn_formRow_error_duplicateHierarchy"
                        >
                          {hasDuplicateHierarchyEntry && (
                            <OnSubmitErrorMessage
                              type="error"
                              message={_.UNIQUE_HIER_VALIDATION_ERROR_MSG}
                            />
                          )}
                        </Form.Row>
                        <Form.Row key="dvn_formRow_Class_Level_Mapping_Doc_Msg">
                          {!viewOnMerchApproval &&
                            store?.documentList?.length > 0 &&
                            !store?.documentList?.some(
                              (doc) => doc.fileType === "BrandMappingTemplate"
                            ) &&
                            !store?.mandatoryDocRes
                              ?.isMandatoryDocumentPresent &&
                            hierarchyArr?.length > 0 &&
                            hierarchyArr?.some(
                              (item) =>
                                item.brandName ===
                                  Constants.MERCHANT_CLASS_LEVEL_MAPPING &&
                                item.vendorNumber === "0"
                            ) && (
                              <Col sm={12} md={10} lg={10} xl={10}>
                                <OnSubmitErrorMessage
                                  type="error"
                                  message={_.CLASS_LEVEL_MAPPING_DOC_MSG}
                                />
                              </Col>
                            )}
                        </Form.Row>
                      </>
                    </Form>
                  )}
                </div>
              </div>
            </>
          )}
        </Col>
      </Row>
      {getDvnSetupErrorFlag() && !viewOnMerchApproval && (
        <div className="mainframeActionRequired-Panel">
          <div className="mainframeActionRequired-main-Header">
            <div className="mainframeActionRequired-Header">
              {_.ACTION_REQUIRED_IN_MAINFRAME}
            </div>
            <div
              className="mainframeActionRequired-main-close"
              onClick={() => {
                setActionRequiredMainframe(false);
              }}
            >
              X
            </div>
          </div>
          <p className="mainframeActionRequired-Content">
            {actionRequiredMessage}
          </p>

          <div className="mainframeActionRequired-footer">
            <Button
              size="sm"
              className="button-primary-note-sm"
              onClick={() => {
                handleMainframeActionRequired();
              }}
            >
              {Constants.BUTTON_OK?.toUpperCase()}
            </Button>
          </div>
        </div>
      )}
    </>
  );
};

export default DVNSetup;
